export default __webpack_public_path__ + "static/media/call.83b66c81.jpg";